import React from 'react'

import { StyledIconMute } from 'component-library/icons/IconMute/IconMute.styled'

export interface Props {
    className?: string
}

export const IconMute: React.FC<Props> = ({ className }) => (
    <StyledIconMute className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 13">
        <g fill="#FFF">
            <path d="M9.62 2.53L1 8.667v-4.25c0-.296.231-.54.526-.557l1.829-.102a.558.558 0 0 0 .288-.1l5.1-3.56a.558.558 0 0 1 .877.456v1.978zm0 5.066v4.85a.558.558 0 0 1-.873.46l-3.353-2.303L9.62 7.596zM12.747 1.61a1 1 0 0 1 1.16 1.63L1.752 11.89a1 1 0 1 1-1.16-1.63l12.154-8.65z" />
        </g>
    </StyledIconMute>
)
